import NoteCreatedEvent from '@/domains/notes/events/NoteCreatedEvent';

const NoteEvents = {
  NoteCreated: NoteCreatedEvent,
};

export default NoteEvents;
